import React from "react"
import { HashLink as Link } from 'react-router-hash-link';
import { Badge, Avatar } from 'antd';


//const postUrlProperties     = API_URL + "properties";

class Header extends React.Component{
  constructor(props){
    super(props);
    this.state = {};
  }

  handleLogout(event) {
    event.preventDefault();
    localStorage.removeItem("api_token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    window.location.reload();
    this.props.setSession(false);
  }

  render(){
    return(
      <header id="main-header">
        <nav>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <Link to="/"><span className="logo-header"> </span></Link>
              </div>
              <div className="col-md-3"></div>
              <div className="col-md-3"></div>
              <div className="col-md-3 segment-filter ">
                <span className="invert-title segment-reserva"></span>
                <div className="row">
                  <div className="col-md-7">
                    <div className="segment-list">
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="profile-options">
                        <div className="row">
                          <div className="col-md-4">
                            <Badge count={this.props.notificationsCount}>
                              <Avatar 
                                style={{ backgroundColor: '#36a9e1' }}
                                shape="circle" icon="bell"
                                size={'large'}
                                onClick={this.props.openStatusNotifications.bind(this)}
                                />
                            </Badge>
                          </div>
                          { /*
                          <div className="col-md-3">
                            <Badge count={this.props.newsCount}>
                            <Avatar 
                                style={{ backgroundColor: '#36a9e1' }}
                                shape="circle" icon="read"
                                size={'large'} />
                            </Badge>
                          </div>
                          */ }
                          <div className="col-md-4">
                            <Avatar 
                                style={{ backgroundColor: '#36a9e1' }}
                                shape="circle" icon="poweroff"
                                size={'large'}
                                onClick={this.handleLogout.bind(this)} />
                         </div>

                        </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    )}
  };

export default Header


// WEBPACK FOOTER //
// ./src/Setup/components/Header.js